<template>
  <el-select
    :disabled="disabled"
    :size="size"
    @change="visibleChange"
    @visible-change="visibleChange" 
    :style="`width:${width}px !important;`"
    filterable
    v-model="value"
    placeholder="请选择"
  >
    <el-option
      :style="`width:300px !important;min-width:300px !important;`"
      v-for="item in clumn"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      ><span style="float: left; color: #f56c6c">{{ item.value }}</span>
      <span style="float: right; margin-left: 20px">{{ item.label }}</span>
    </el-option>
  </el-select>
</template>
<script>
import { classifyList } from "@/api/merchant.js";
import { permissionMerchantList } from "@/api/merchant.js";
import { queryBranch, queryOfflineClassify,getSupcust } from "@/api/offlinestores.js";
import tablecardVue from "../pages/shop/pages/warehouse/components/tablecard.vue";
// import { testR } from "@/api";
export default {
  name: "wty-select",
  props: ["who", "width", "size", "offlineclasslist", "disabled"],
  data() {
    return {
      clumn: [],
      value: "",
      weightFlag: [
        {
          label: "普通商品",
          value: 0
        },
        {
          label: "称重商品",
          value: 1
        },
        {
          label: "计数商品",
          value: 2
        }
      ]
    };
  },
  watch: {
    value: {
      handler(newv, oldv) {
        this.$emit("getReturn", {
          who: this.who,
          value: newv
        });
      }
    }
  },
  async mounted() {
    this.clumn = [];
    this.visibleChange(true);
    /* try {
      var a = await querySupplier();
      console.log("a-----------------------------", a);
    } catch (e) {
      console.log(e);
    } */
  },
  methods: {
    async visibleChange(e) {
      console.log(e);
      if (!e) {
        return;
      }
      if (this.who == "class_no") {
        const res = await classifyList();
        this.clumn = [];
        for (let i = 0; i < res.length; i++) {
          this.clumn.push({
            label: res[i].class_name,
            value: res[i].class_no
          });
        }
      } else if (this.who == "weight_flag") {
        this.clumn = [];
        this.clumn = this.weightFlag;
      } else if (this.who == "merchant") {
        const res = await permissionMerchantList();
        this.clumn = [];
        for (let i = 0; i < res.length; i++) {
          this.clumn.push({
            label: res[i].sub_name,
            value: res[i].merchant_id
          });
        }
      } else if (this.who == "branch") {
        const res = await queryBranch();
        this.clumn = [];
        for (let key in res) {
          this.clumn.push({
            label: res[key],
            value: key
          });
        }
      } else if (this.who == "offlineclass") {
        this.clumn = [];

        const res = await queryOfflineClassify();
        for (let i = 0; i < res.length; i++) {
          this.clumn.push({
            label: res[i].class_name,
            value: res[i].class_no
          });
        }
      } else if (this.who == "sup") {
        this.clumn = [];
        const res = await getSupcust();
        for (let i = 0; i < res.length; i++) {
          this.clumn.push({
            label: res[i].sup_name,
            value: res[i].sup_no
          });
        }
      }
    },
    setSelect(value) {
      this.visibleChange();
      this.value = value;
    }
  }
};
</script>
<style scoped lang="less">
.el-input .el-input__inner {
  width: 300px !important;
}
</style>
